import { useEffect, useState } from 'react';
import { useCart } from '../../hooks/useCart';
import ProductOptionsSheet from '../Business/ProductOptionsSheet';

/**
 * Hoja de extras global para el "+" de las tarjetas (`quickAdd` del carrito).
 * Vive en el layout, fuera del slider con transform del home, para que su
 * `position: fixed` se ancle a la pantalla.
 *
 * Guarda el último producto para que la hoja pueda animar su salida: al
 * cerrar, `customizing` pasa a null antes de que termine la animación.
 */
export default function QuickAddOptions() {
  const { customizing, closeCustomizing, addItem } = useCart();
  const [producto, setProducto] = useState(null);

  useEffect(() => {
    if (customizing) setProducto(customizing);
  }, [customizing]);

  const actual = customizing || producto;
  if (!actual) return null;

  return (
    <ProductOptionsSheet
      isOpen={!!customizing}
      onClose={closeCustomizing}
      product={actual}
      onConfirm={(prod, qty, extras) => addItem(prod, qty, extras)}
    />
  );
}
